import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import api from "@/lib/api";
import { toast } from "sonner";

export default function NotifyMeDialog({ car, trigger }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/inquiries", {
        type: "interest",
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        car_id: car.id,
        message: form.message || `Interested in the ${car.year} ${car.make} ${car.model} — please let me know when it's available.`,
      });
      toast.success("You're on the list! We'll reach out as soon as it's ready.");
      setOpen(false);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong — please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-md" data-testid="notify-me-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl text-primary">Get first dibs</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground -mt-2">
          The {car.year} {car.make} {car.model} is almost ready. Leave your info and we&rsquo;ll call you before it hits the lot.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="nm-name">Name *</Label>
            <Input id="nm-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="notify-name-input" />
          </div>
          <div>
            <Label htmlFor="nm-email">Email *</Label>
            <Input id="nm-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="notify-email-input" />
          </div>
          <div>
            <Label htmlFor="nm-phone">Phone</Label>
            <Input id="nm-phone" type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="notify-phone-input" />
          </div>
          <div>
            <Label htmlFor="nm-msg">Anything we should know?</Label>
            <Textarea id="nm-msg" rows={2} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="notify-message-input" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={submitting} className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-sm w-full" data-testid="notify-submit">
              {submitting ? "Sending…" : "I'm Interested"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
